import { Maybe } from "true-myth";

import { UserActionTypes, UserTypeKeys } from "actions/user";

import { IUserState } from "types/reducers";

import { RequestStatus } from "types/requests";

const initialState: IUserState = {
  userRequestStatus: RequestStatus.NOT_STARTED,
  email: "",
  firstName: Maybe.nothing(),
  lastName: Maybe.nothing(),
};

export default function user(
  state: IUserState = initialState,
  action: UserActionTypes
): IUserState {
  switch (action.type) {
    case UserTypeKeys.REQUEST_USER:
      return {
        ...state,
        userRequestStatus: action.userRequestStatus,
      };

    case UserTypeKeys.RECEIVE_USER: {
      const { appUser, userRequestStatus } = action;
      return {
        ...state,
        email: appUser.email,
        firstName: appUser.firstName,
        lastName: appUser.lastName,
        userRequestStatus,
      };
    }
    default: {
      return state;
    }
  }
}
